import React from 'react';

import styles from './fixed-header.scss';

interface Props {
  children: any;
}

const FixedHeader = ({ children }: Props) => {
  return <header className={styles.header}>{children}</header>;
};

export default FixedHeader;
